import { RaciStepTemplateModel } from "./raci-step-template-model";
import { RaciTaskTemplateModel } from "./raci-task-template-model";

export class RaciTemplateModel {
  /**
 * The ID of the entity.
 */
  oid: number;

  /**
   * The name of the entity.
   */
  name: string;

  /**
   * The status of the entity.
   */
  status: number;

  /**
   * Indicates whether the entity is used in a portfolio.
   */
  isUsedInPortfolio: boolean;

  /**
   * The steps associated with the entity.
   */
  steps: RaciStepTemplateModel[];

  /**
   * The tasks associated with the entity.
   */
  tasks: RaciTaskTemplateModel[];
}
